import { render, staticRenderFns } from "./impersonate-table.vue?vue&type=template&id=5fd01398"
import script from "./impersonate-table.vue?vue&type=script&lang=js"
export * from "./impersonate-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports